import React from 'react';
import styled from 'styled-components';
import mediaQueries from '../../styles/mediaQueries';
import { colors } from '../../styles/constants';

import BurgerMenu from './hamburgermenu.svg';
import CloseMenu from './closemenu.svg';
// import calculateRem from '../../styles/calculateRem';

interface NavBarProps {
  isHidden?: boolean,
};

// TODO: The types here will need to be examined once we've fixed the media queries.
const NavBar = styled.ul<NavBarProps>`
  padding: 0;
  ${mediaQueries.tablet`
    position: fixed;
    width: 260px;
    top: 60px;
    right: 0;
    bottom: 0;
    height: 100%;
    text-align: right;
    background: ${colors.darkPurple};
    transform: ${(props: any) =>
      props.isHidden ? 'translate(280px)' : 'translate(0)'};
  `};
`;

const NavLink = styled.li`
  display: inline;
  margin: 0 24px;
  ${mediaQueries.tablet`
    display: block;
    margin: 12px 24px;
  `};
`;

const Link = styled.a`
  text-decoration: none;
  color: ${colors.orange};
`;

const Burger = styled.button`
  background: transparent;
  border: none;
  margin-left: 24px;
  height: 30px;
  width: 30px;
  display: none;
  ${mediaQueries.tablet`
    display: flex;
    justify-content: center;
    align-items: center;
  `};
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: 0;
  }
`;

const navLinks = [
  {
    link: '/about',
    label: 'About us'
  },
  {
    link: '/funding-information',
    label: 'Funding Information'
  },
  {
    link: '/list-your-organisation',
    label: 'For Providers'
  },
  {
    link: 'https://info.karista.com.au/blog/',
    label: 'Blog'
  }
];

const NavButtons = ({ isHidden }) => (
  <NavBar isHidden={isHidden}>
    {navLinks.map(link => (
      <NavLink key={`nav-link-${link.label}`}>
        <Link href={link.link} rel="dofollow">
          {link.label}
        </Link>
      </NavLink>
    ))}
  </NavBar>
);

export const Hamburger = ({ handleClick, showBurger }) => (
  <Burger onClick={handleClick}>
    {showBurger ? (
      <img src={BurgerMenu} alt="menu" />
    ) : (
      <img src={CloseMenu} alt="close the menu" />
    )}
  </Burger>
);

export default NavButtons;
